import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_GROUPITEMTEMPLATECATEGORY_LOAD,
    ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_BY_ID,

    ACTION_GROUPITEMTEMPLATECATEGORY_SAVE,

    ACTION_GROUPITEMTEMPLATECATEGORY_CREATE,

    ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE,

    IGroupItemTemplateCategoryLoadAction,
    IGroupItemTemplateCategoryLoadByIdAction,
    IGroupItemTemplateCategoryLoadFailureAction,
    IGroupItemTemplateCategoryLoadSuccessAction,

    IGroupItemTemplateCategorySaveAction,
    IGroupItemTemplateCategorySaveSuccessAction,
    IGroupItemTemplateCategorySaveFailureAction,

    IGroupItemTemplateCategoryValidateAction,
    IGroupItemTemplateCategoryValidateSuccessAction,
    IGroupItemTemplateCategoryValidateFailureAction,

    IGroupItemTemplateCategoryCreateAction,
    IGroupItemTemplateCategoryCreateSuccessAction,
    IGroupItemTemplateCategoryCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    ValidateSuccess,
    ValidateFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/groupItemTemplateCategory";
import { groupItemTemplateCategorysApi } from "../services/groupItemTemplateCategory";


export const
    getGroupItemTemplateCategorysEpic = (action$): Observable<IGroupItemTemplateCategoryLoadSuccessAction | IGroupItemTemplateCategoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMTEMPLATECATEGORY_LOAD)
            .mergeMap((_action: IGroupItemTemplateCategoryLoadAction) => {
                return groupItemTemplateCategorysApi
                    .getGroupItemTemplateCategorys()
                    .map(response =>
                        LoadSuccess(response.groupItemTemplateCategorys, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getGroupItemTemplateCategoryByIdEpic = (action$): Observable<IGroupItemTemplateCategoryLoadSuccessAction | IGroupItemTemplateCategoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMTEMPLATECATEGORY_LOAD_BY_ID)
            .mergeMap((action: IGroupItemTemplateCategoryLoadByIdAction) => {
                return groupItemTemplateCategorysApi
                    .getGroupItemTemplateCategoryById(action.id)
                    .map(response =>
                        LoadSuccess(response.groupItemTemplateCategory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setGroupItemTemplateCategoryEpic = (action$): Observable<IGroupItemTemplateCategorySaveSuccessAction | IGroupItemTemplateCategorySaveFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMTEMPLATECATEGORY_SAVE)
            .mergeMap((action: IGroupItemTemplateCategorySaveAction) => {
                return groupItemTemplateCategorysApi
                    .setGroupItemTemplateCategory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.groupItemTemplateCategory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createGroupItemTemplateCategoryEpic = (action$): Observable<IGroupItemTemplateCategoryCreateSuccessAction | IGroupItemTemplateCategoryCreateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMTEMPLATECATEGORY_CREATE)
            .mergeMap((_action: IGroupItemTemplateCategoryCreateAction) => {
                return groupItemTemplateCategorysApi
                    .createGroupItemTemplateCategory()
                    .map(response =>
                        CreateSuccess(
                            response.groupItemTemplateCategory,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateGroupItemTemplateCategoryEpic = (action$): Observable<IGroupItemTemplateCategoryValidateSuccessAction | IGroupItemTemplateCategoryValidateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMTEMPLATECATEGORY_VALIDATE)
            .mergeMap((action: IGroupItemTemplateCategoryValidateAction) => {
                return groupItemTemplateCategorysApi
                    .validateGroupItemTemplateCategory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.groupItemTemplateCategory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



